export const IS_SSN_LOCKED_COLOR = "#FFC107";
export const IS_SSN_UNLOCKED_COLOR = "#009A1E";